module.exports = __webpack_public_path__ + "img/logo.3b00d7ed.png";